import React from 'react';
import { ContentCopy, CheckCircle } from '@mui/icons-material';

const CodeBlock = ({ code, language = 'javascript' }) => {
    const [copied, setCopied] = React.useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            // ignore
        }
    };

    return (
        <div className="mt-3 rounded-2xl overflow-hidden border border-slate-200/90 bg-white shadow-sm dark:border-slate-700/70 dark:bg-slate-900/40">
            <div className="flex items-center justify-between px-4 py-2.5 border-b border-slate-200/80 bg-slate-50/70 dark:border-slate-700/70 dark:bg-slate-900/60">
                <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
                    {language}
                </span>
                <button
                    type="button"
                    onClick={copy}
                    className="inline-flex items-center gap-2 px-2.5 py-1.5 rounded-xl border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
                    aria-label="Copier le code"
                >
                    {copied ? <CheckCircle className="text-emerald-500" fontSize="small" /> : <ContentCopy fontSize="small" />}
                    <span className="text-xs font-semibold">{copied ? 'Copié' : 'Copier'}</span>
                </button>
            </div>
            <pre className="text-slate-100 text-[13px] leading-relaxed overflow-x-auto p-4 bg-slate-950/95 dark:bg-slate-950/95">
                <code>{code}</code>
            </pre>
        </div>
    );
};

export default CodeBlock;